import React, { Suspense, useState, lazy, useRef } from "react";
import {
  Card,
  CardContent,
  Grid,
  Dialog,
  CardActionArea,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { grey } from "@mui/material/colors";
import StatSkeleton from "../components/common/StatSkeleton";
import DottedTile from "../components/common/DottedTile";
import CreateVehicleModelTile from "../components/vehicle/model/CreateVehicleModelTile";
import VehicleModelsStats from "../components/vehicle/model/VehicleModelsStats";
import VehicleModelsDataGrid from "../components/vehicle/model/VehicleModelsDataGrid";
import VehicleModelTrimsTab from "../components/vehicle/model/VehicleModelTrimsTab";

const CreateVehicleTrim = lazy(() => import("../components/vehicle/model/CreateVehicleTrim"));

const VehicleModels = () => {
  const [expandedModel, setExpandedModel] = useState(null);
  const [trimDialogOpen, setTrimDialogOpen] = useState(false);
  const [trimDialogModel, setTrimDialogModel] = useState(null);
  const trimsRef = useRef(null);

  const handleViewTrims = (model) => {
    setExpandedModel((current) => {
      const newModel = current?.modelId === model.modelId ? null : model;

      if (newModel) {
        setTimeout(() => {
          trimsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }

      return newModel;
    });
  };

  const handleOpenTrimDialog = (model = null) => {
    setTrimDialogModel(model);
    setTrimDialogOpen(true);
  };

  const handleCloseTrimDialog = () => {
    setTrimDialogOpen(false);
    setTrimDialogModel(null);
  };

  return (
    <div className="fragmentContainer">
      <Grid container spacing={2}>
        <Suspense fallback={<StatSkeleton />}>
          <VehicleModelsStats />
        </Suspense>
        <CreateVehicleModelTile />
        <Grid item xs={6} sm={4} md={2}>
          <CardActionArea onClick={() => handleOpenTrimDialog(null)}>
            <DottedTile title={"CREATE A TRIM"}>
              <AddCircleOutlineIcon sx={{ fontSize: "3.5rem", color: grey[500] }} />
            </DottedTile>
          </CardActionArea>
        </Grid>
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <VehicleModelsDataGrid
                tableTitle="Available Vehicle Models"
                onViewTrims={handleViewTrims}
                onAddTrim={handleOpenTrimDialog}
              />
            </CardContent>
          </Card>
        </Grid>

        {expandedModel && (
          <Grid item xs={12} ref={trimsRef}>
            <Card>
              <CardContent sx={{ p: 2 }}>
                <VehicleModelTrimsTab 
                  modelId={expandedModel.modelId}
                  modelName={expandedModel.name}
                  tableSx={{minHeight: 330}}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      {trimDialogOpen && (
        <Dialog
          open
          onClose={handleCloseTrimDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
            },
          }}
        >
          <Suspense fallback={<StatSkeleton />}>
            <CreateVehicleTrim
              modelId={trimDialogModel?.modelId}
              modelName={trimDialogModel?.name}
              toggleDialog={handleCloseTrimDialog}
            />
          </Suspense>
        </Dialog>
      )}
    </div>
  );
};

export default VehicleModels;